import {GET_CHANNEL_DETAIL_START, GET_CHANNEL_DETAIL} from '../constants/index';

const initialState = {
};

const channel = (state = initialState, {type, seoName, data}) => {
	switch (type) {
		case GET_CHANNEL_DETAIL_START:
			return {
				...state,
				[seoName]: {
					...state[seoName],
					detail: {
						data: null,
						isLoading: true,
					},
				},
			};
		case GET_CHANNEL_DETAIL: {
			// code: failedgeo/Failed, message: error
			let info = null;
			if (JSON.stringify(data) === '{}') {
				info = {
					seoName,
					noAccess: true,
					code: 'Failed',
				};
			} else if (data && data.code && data.code.toLowerCase() === 'failed') {
				info = {
					seoName,
					noAccess: true,
					code: 'Failed',
				};
			} else if (data && data.message) {
				info = {
					seoName,
					noAccess: true,
					code: 'Failed',
				};
			} else if (data && data.code && data.code.toLowerCase() === 'failedgeo') {
				info = {
					seoName,
					noAccess: true,
					code: 'Blackout',
				};
			} else {
				info = {
					seoName,
					...data,
					noAccess: undefined,
					code: data.blackout ? 'Blackout' : undefined,
				};
			}

			return {
				...state,
				[seoName]: {
					...state[seoName],
					detail: {
						data: info,
						isLoading: false,
					},
				},
			};
		}
		default:
			return state;
	}
};

export default channel;
